import { render, staticRenderFns } from "./Marcas.vue?vue&type=template&id=5db6776d"
import script from "./Marcas.vue?vue&type=script&lang=js"
export * from "./Marcas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports